export const plusPath = "<path d=\"M8 3.5 V12.5 M3.5 8 H12.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>"
